import { z } from 'zod';

export type ActivityLogForeignKey = {
  key: string;
  value: number;
};

export const ActivityLogTypeEnum = z.enum([
  'CREATE',
  'UPDATE',
  'DELETE',
  'ARCHIVE',
  'DEACTIVATE',
  'ACTIVATE',
  'LINK',
  'UNLINK',
  'ADD',
  'REMOVE',
  'OTHER',
]);
export type ActivityLogType = z.infer<typeof ActivityLogTypeEnum>;

export const ActivityLogTextSchema = z.object({
  logType: ActivityLogTypeEnum,
  entity: z.string(),
  entityId: z.number().optional(),
  value: z.string(),
  metadata: z.object({}).passthrough().optional(),
});
export type ActivityLogTextDto = z.infer<typeof ActivityLogTextSchema>;

export const ActivityLogSchema = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  userId: z.string().max(50),
  logType: ActivityLogTypeEnum,
  text: z.string(),
  changeLog: z.array(ActivityLogTextSchema).optional(),
  currentValue: z.object({}).passthrough().optional(),
  details: z.object({}).passthrough().optional(), // deprecated
  feedbackId: z.number().nullish(),
  feedbackFormId: z.number().nullish(),
  ideaId: z.number().nullish(),
  productId: z.number().nullish(),
  customerId: z.number().nullish(),
  contactId: z.number().nullish(),
  customFieldId: z.number().nullish(),
  portalId: z.number().nullish(),
  ideaViewId: z.number().nullish(),
  demandViewId: z.number().nullish(),
  demandId: z.number().nullish(),
  demandCommentId: z.number().nullish(),
  demandReviewerId: z.number().nullish(),
  demandAttachmentId: z.number().nullish(),
  demandEvidenceId: z.number().nullish(),
  // The wire carries ISO strings, not Date instances - JSON has no date type. Coercing to Date here
  // would only be accurate if something on the read path actually called .parse(); since it doesn't,
  // the inferred type has to match what callers actually receive.
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  entityName: z.string().optional().nullable(),
  contactName: z.string().optional().nullable(),
});
export type ActivityLogDto = z.infer<typeof ActivityLogSchema>;

export const CreateActivityLogSchema = ActivityLogSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
}).extend({
  changeLog: z.array(ActivityLogTextSchema).default([]).optional(),
});
export type CreateActivityLogDto = z.infer<typeof CreateActivityLogSchema>;
